import { Button, Col, Label, Panel, Row } from 'react-bootstrap';
import { IEmpletAllele } from '@nkr/models/index';
import { AlleleType } from '@nkr/enums/index';
import AlleleDetails from '@nkr/views/swap-management/allele-details';
import { AlleleListWrapper } from './styles';

interface IProps {
    recipientId: number,
    donorId: number,
    recipientAlias: string,
    donorAlias: string,
    recipientAlleles: IEmpletAllele[],
    donorAlleles: IEmpletAllele[],
    downloadFile: (recipientId: number, donorId: number) => void
}

const AllelesSearched = (props: IProps) => {
    let recipientHlaA = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('A'));
    let recipientHlaB = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('B'));
    let recipientHlaC = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('C'));
    let recipientHlaDrb1 = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DRB1'));
    let recipientHlaDrbx = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DRB3') || allele.hlaDisplay.startsWith('DRB4') || allele.hlaDisplay.startsWith('DRB5'));
    let recipientHlaDqb = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DQB'));
    let recipientHlaDqa = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DQA'));
    let recipientHlaDpb = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DPB'));
    let recipientHlaDpa = props.recipientAlleles.filter(allele => allele.hlaDisplay.startsWith('DPA'));

    let donorHlaA = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('A'));
    let donorHlaB = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('B'));
    let donorHlaC = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('C'));
    let donorHlaDrb1 = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DRB1'));
    let donorHlaDrbx = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DRB3') || allele.hlaDisplay.startsWith('DRB4') || allele.hlaDisplay.startsWith('DRB5'));
    let donorHlaDqb = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DQB'));
    let donorHlaDqa = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DQA'));
    let donorHlaDpb = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DPB'));
    let donorHlaDpa = props.donorAlleles.filter(allele => allele.hlaDisplay.startsWith('DPA'));

    return (
        <div className='row'>
            <div className='col-xs-12'>
                <Panel bsStyle="primary">
                    <Panel.Heading>
                        Alleles Searched
                        {props.donorId && props.recipientId && (
                            <Button bsSize='xsmall' bsStyle='default' className='pull-right' onClick={() => props.downloadFile(props.recipientId, props.donorId)}>
                                <span className='glyphicon glyphicon-file'></span> Get Results as PDF
                            </Button>
                        )}
                    </Panel.Heading>
                    <Panel.Body>
                        <div>
                            <Row className='no-print'>
                                <Col xs={12} sm={5}>
                                    <p className='small'>click allele for additional details</p>
                                </Col>
                                <Col xs={12} sm={7}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ display: 'flex', marginRight: 20 }}>
                                            <Label bsStyle='success'>&nbsp;</Label>&nbsp;- no mismatches
                                        </div>
                                        <div style={{ display: 'flex', marginRight: 20 }}>
                                            <Label bsStyle='warning'>&nbsp;</Label>&nbsp;- mismatches
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <Label style={{ backgroundColor: '#ffffff', border: '1px solid #8c8c8c' }}>&nbsp;</Label>&nbsp;- not expressed / missing
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <div id='recipAlleleResponse'>
                                        <h4 className='heading'>Recipient Alleles{props.recipientAlias ? ` (${props.recipientAlias})` : ""}</h4>
                                        <AlleleListWrapper>
                                            <div id='ra_A' className='allele-list'>
                                                {recipientHlaA.map((allele, index) =>
                                                    <AlleleDetails key={'allele-a-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_B' className='allele-list'>
                                                {recipientHlaB.map((allele, index) =>
                                                    <AlleleDetails key={'allele-b-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_C' className='allele-list'>
                                                {recipientHlaC.map((allele, index) =>
                                                    <AlleleDetails key={'allele-c-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DRB1' className='allele-list'>
                                                {recipientHlaDrb1.map((allele, index) =>
                                                    <AlleleDetails key={'allele-drb1-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DRBX' className='allele-list'>
                                                {recipientHlaDrbx.map((allele, index) =>
                                                    <AlleleDetails key={'allele-drbx-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DQB' className='allele-list'>
                                                {recipientHlaDqb.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dqb-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DQA' className='allele-list'>
                                                {recipientHlaDqa.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dqa-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DPB' className='allele-list'>
                                                {recipientHlaDpb.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dpb-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='ra_DPA' className='allele-list'>
                                                {recipientHlaDpa.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dpa-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.RecipientAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>
                                        </AlleleListWrapper>
                                    </div>

                                </Col>
                                <Col xs={12} style={{ marginTop: '8px' }}>
                                    <div id='donorAlleleResponse'>
                                        <h4 className='heading'>Donor Alleles{props.donorAlias ? ` (${props.donorAlias})` : ""}</h4>

                                        <AlleleListWrapper>
                                            <div id='da_A' className='allele-list'>
                                                {donorHlaA.map((allele, index) =>
                                                    <AlleleDetails key={'allele-a-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_B' className='allele-list'>
                                                {donorHlaB.map((allele, index) =>
                                                    <AlleleDetails key={'allele-b-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_C' className='allele-list'>
                                                {donorHlaC.map((allele, index) =>
                                                    <AlleleDetails key={'allele-c-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DRB1' className='allele-list'>
                                                {donorHlaDrb1.map((allele, index) =>
                                                    <AlleleDetails key={'allele-drb1-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DRBX' className='allele-list'>
                                                {donorHlaDrbx.map((allele, index) =>
                                                    <AlleleDetails key={'allele-drbx-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DQB' className='allele-list'>
                                                {donorHlaDqb.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dqb-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DQA' className='allele-list'>
                                                {donorHlaDqa.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dqa-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DPB' className='allele-list'>
                                                {donorHlaDpb.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dpb-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>

                                            <div id='da_DPA' className='allele-list'>
                                                {donorHlaDpa.map((allele, index) =>
                                                    <AlleleDetails key={'allele-dpa-donor-' + index} alleles={allele} dismiss={true} allelesType={AlleleType.DonorAllele} isAdmin={false} placement='top' />
                                                )}
                                            </div>
                                        </AlleleListWrapper>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Panel.Body>
                </Panel>
            </div>
        </div>
    );
}

export default AllelesSearched;